import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR, SIZE, FONT_FAMILY } from '../../utils/constants.js'
import { Label } from '../atoms/label.jsx'


const Content = styled.div`
    margin: ${props => props.margin ? props.margin : '0'};
`;

const Underline = styled.div`
    width: 200px;
    height: 4px;
    background-color: ${props => props.bg_color ? props.bg_color : COLOR.primary};
    margin-top: 10px;
`;


const TitleSect = (props) => {
    return (
        <Content 
            margin={props.margin}>
            <Label
                text_size={props.size ? props.size : SIZE.display}
                text_color={props.color ? props.color : COLOR.secondary}
                font_family={FONT_FAMILY.noteworthyBold}>
                {props.children}
            </Label>
            <Underline
                bg_color={props.color ? props.color : COLOR.secondary}/>
        </Content>
    );
}

TitleSect.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string, 
    margin: PropTypes.string,
}

export default TitleSect;